import CancelIcon from '@mui/icons-material/Cancel'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Backdrop, Box, Button, CircularProgress, Paper, Stack, Typography } from '@mui/material'
import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import useClientData from '../../hooks/useClientData'
import useConfiguration from '../../hooks/useConfiguration'
import useSendTo from '../../hooks/useSendTo'

const Redirect = () => {
  const { t } = useTranslation()

  const { configuration } = useConfiguration()
  const { clientData, error } = useClientData()
  const { isLoading } = useSendTo()

  const provider = configuration?.webview.provider === 'wa' ? 'whatsapp' : 'messenger'
  const invalidSocialNumber = error && error.status === 404 && !clientData.document

  const handleSendTo = useCallback(() => {
    window.location.href = `http://${configuration?.webview.provider === 'wa' ? 'wa' : 'm'}.me/${
      configuration?.webview.botNumber
    }`
  }, [configuration])

  const [statusIcon, statusTitle, statusSubTitle] = useMemo(() => {
    let icon = <CheckCircleIcon htmlColor="rgb(151, 151, 151)" style={{ fontSize: '60px' }} />
    let title = t('redirect.successfulLogin')
    let subTitle = t('redirect.confirm', { provider })

    if (invalidSocialNumber) {
      icon = <CancelIcon htmlColor="rgb(205, 25, 25)" style={{ fontSize: '60px', color: '#ff7961' }} />
      title = t('redirect.documentNotFound')
      subTitle = t('redirect.tryAgain', { provider })
    }

    return [icon, title, subTitle]
  }, [invalidSocialNumber, provider])

  return (
    <Stack direction="column" p={4} height="100%">
      <Box display="flex" justifyContent="center" marginBottom={5}>
        <Paper elevation={0} style={configuration?.extensions.webviewCustomizations?.logo}>
          <img
            loading="lazy"
            width="100%"
            height="100%"
            alt={`${configuration?.name} logo`}
            src={configuration?.webview.theme.logo}
          />
        </Paper>
      </Box>

      <Box display="flex" justifyContent="center" marginBottom={6}>
        {statusIcon}
      </Box>

      <Box>
        <Typography
          gutterBottom
          variant="h6"
          fontWeight="600"
          textAlign="center"
          color={invalidSocialNumber ? '#616161' : configuration?.webview.theme.customerColor}
        >
          {statusTitle}
        </Typography>

        <Typography variant="subtitle2" textAlign="center" gutterBottom>
          {statusSubTitle}
        </Typography>
      </Box>

      <Button
        fullWidth
        size="large"
        variant="contained"
        type="submit"
        style={{
          ...configuration?.extensions.webviewCustomizations?.backToChatButton,
          marginTop: '10px',
        }}
        onClick={handleSendTo}
      >
        {`Voltar ao ${provider}`}
      </Button>

      <Box position="relative" height="100%">
        <Backdrop
          sx={{
            bottom: '20%',
            position: 'absolute',
            backgroundColor: 'transparent',
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress
            size={80}
            style={{ position: 'absolute', bottom: '0', color: configuration?.webview.theme.customerColor }}
          />
        </Backdrop>
      </Box>
    </Stack>
  )
}

export default Redirect
